import angular from "angular";
import resolve from "ioc/resolve";
import orderBy from "lodash/orderBy";
import sortBy from "lodash/sortBy";
import $pageConfig from "webutils/services/page-config";

class AutoQueryTagFilter {
  constructor(config, $aq) {
    const g = this;
    const tagKind =
      config.tagKind || config.tag || config.nav || config.toString();
    Object.assign(g, config);
    g.formatter = config.formatter || ((t) => t.tagLabel);
    g.type = "tag";
    g.tagKind = tagKind;
    g.lowerTagKind = tagKind.toLowerCase();
    g.title = config.title || tagKind;
    g.query = $aq;
    g.bus = $aq.bus;
    g.filtered = 1;
    if ($aq.tagTotalsUrl) {
      g.$$url = `${
        $aq.tagTotalsUrl + ($aq.tagTotalsUrl.indexOf("?") > 0 ? "&" : "?")
      }TagKind=${encodeURIComponent(tagKind)}`;
    }
    g.items = [];
    g.processing = new Date();
    g.forceResetItems = false;
    if (!$aq.criteria.tagCriteria) $aq.criteria.tagCriteria = {};
    if (config.value)
      $aq.criteria.tagCriteria[tagKind] = Array.isArray(config.value)
        ? config.value
        : [config.value];
    g.baseCriteria = { ...$aq.criteria };
    delete g.baseCriteria.tagCriteria;
  }

  isSelected(tag) {
    const g = this;
    return tag && g.getParams().indexOf(tag.tagLabel) >= 0;
  }

  mapItems(res) {
    const g = this;
    return res.data.results;
  }

  init(force = false) {
    const g = this;
    // console.debug("AutoQueryTagFilter$init", g.$$url, { force, ...g });
    if (g.hidden) return false;
    if (!force && g.$$init) return g.$$init;

    const $q = resolve("$q");
    g.setItems([]);
    g.$$init = $q.resolve(g.items);
    // https://emun1.monday.com/boards/333027351/views/4635648/pulses/4289098423
    return g.$$init;
    const action = g.query.httpMethod == "POST" ? "send" : "read";
    return (g.$$init = g.bus[action](g.$$url, g.baseCriteria).then((res) => {
      const items = g.mapItems(res);
      g.setItems(items);
      return g.items;
    }));
  }

  readQueryString(fieldName, value) {
    const g = this;
    if (fieldName.toLowerCase() === g.lowerTagKind) {
      // console.info("readQueryString", g.lowerTagKind, { fieldName, value, g });
      let values = (value || "")
        .split(AutoQueryTagFilter.qsDelimiter)
        .filter((m) => m);
      if (g.readQueryStringShouldHydrate(values)) {
        g.query.criteria.tagCriteria[g.tagKind] = values;
        // console.warn("$rqs", g.tagKind, values);
      }
    }
  }

  readQueryStringShouldHydrate(values) {
    const g = this;
    let exists = Object.keys(g.query.criteria.tagCriteria)
      .map((k) => k.toLowerCase())
      .indexOf(g.lowerTagKind);
    // console.warn("readQueryStringShouldHydrate", g.lowerTagKind, {
    //   exists,
    //   values,
    //   tc: { ...g.query.criteria.tagCriteria },
    //   g,
    //   result: exists === -1 && values.length,
    // });
    return exists === -1 && values.length;
  }

  writeQueryString(params) {
    const g = this;
    let locals = g.getParams();
    // console.warn("writeQueryString", g.lowerTagKind, {
    //   locals,
    //   tc: { ...g.query.criteria.tagCriteria },
    //   g,
    // });
    if (Array.isArray(locals) && locals.filter((m) => !!m).length) {
      params[g.tagKind] = locals.join(AutoQueryTagFilter.qsDelimiter);
    }
  }

  scrubParams(_params) {
    const g = this;
    let params = angular.merge({}, _params);
    if (params.tagCriteria) delete params.tagCriteria[g.tagKind];
    delete params.page;
    delete params.pageSize;
    delete params.orderBy;
    delete params.fields;
    delete params.Fields;
    return params;
  }

  setItems(items) {
    const g = this;
    g.items = [];
    items.forEach((item) => {
      if (item.tagLabel && item.tagLabel.length) {
        item.filtered = item.total;
        g.items.push(item);
      }
    });
    if (g.sortBy) {
      g.items = sortBy(g.items, g.sortBy);
    }
    if (g.orderBy) {
      g.items = orderBy(g.items, ...g.orderBy);
    }
  }

  process(_params) {
    const g = this;
    if (g.hidden || g.suppressItems) return false;
    let params = g.scrubParams(_params);
    g.processing = new Date();
    g.processed = false;
    // console.debug("AutoQueryTagFilter$process", g.$$url, _params);
    return g.init().then(() => {
      params.sortBy = params.take = params.skip = null;
      const action = g.query.httpMethod == "POST" ? "send" : "read";
      // console.info("process$req", g.$$url, params);
      return g.bus[action](g.$$url, params)
        .then((res) => {
          // console.info("process$res", g.$$url, res);
          g.processed = new Date();
          g.processing = false;
          g.filtered = 0;
          return g.mapItems(res);
        })
        .then((items) => {
          const totals = {};
          items.forEach((m) => (totals[m.tagLabel] = m.total));
          // https://emun1.monday.com/boards/333027351/views/4635648/pulses/4289098423
          // if (g.items.length === 0 || g.forceResetItems) {
          g.setItems(items);
          // }
          g.items.forEach((item) => {
            item.filtered = totals[item.tagLabel] || 0;
            g.filtered += item.filtered;
          });
          // https://emun1.monday.com/boards/333027351/views/4635648/pulses/872003434?advancedFilters=true&people=person-10628996
          g.onProcessed && g.onProcessed(g, g.query);
          return g.items;
        });
    });
  }

  any() {
    const g = this;
    return g.getParams().length > 0;
  }

  getParams() {
    const g = this;
    return (
      g.query.criteria.tagCriteria[g.tagKind] ||
      (g.query.criteria.tagCriteria[g.tagKind] = [])
    ); //.filter(m=>m);
  }

  contains(tagLabel) {
    const g = this;
    return g.isSelected(tagLabel);
  }

  clear() {
    const g = this;
    delete g.query.criteria.tagCriteria[g.tagKind];
    g.onCleared && g.onCleared(g);
  }

  getRefinements() {
    const g = this;
    if (g.hidden && !g.showRefinement) return [];
    return g.getParams().map((tagLabel) => {
      // find item by tagLabel
      let item = g.items.find((m) => m.tagLabel === tagLabel) || { tagLabel };
      return {
        label: g.formatter ? g.formatter(item, g) : tagLabel,
        remove() {
          g.toggle(item);
          !g.any() && g.onCleared && g.onCleared(g);
        },
      };
    });
  }

  toggle(tag) {
    const g = this;
    let list = g.getParams();
    let index = list.indexOf(tag.tagLabel);
    if (g.useRadioButtons) {
      if (index > -1) delete g.query.criteria.tagCriteria[g.tagKind];
      else g.query.criteria.tagCriteria[g.tagKind] = [tag.tagLabel];
    } else {
      if (index > -1) list.splice(index, 1);
      else list.push(tag.tagLabel);
    }
    if (g.forceOrderBy && index === -1) g.query.sort(g.forceOrderBy);
    else g.query.load(true);
    g.query.scrollTop && $pageConfig && $pageConfig.goTop();
  }
}

AutoQueryTagFilter.qsDelimiter = "|";

export default AutoQueryTagFilter;
